import { __assign, __extends } from "tslib";
import React from 'react';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { PnmacMediaQuery, PnmacRadioButton, PnmacUIButton, PnmacText, PnmacPaper, PnmacRowHeader, PnmacParagraph, PnmacTextInput, PnmacMeta } from 'pnmac-universal-components';
import styles from '../../styles/styles.js';
import { SuccessMessage } from '../../components/SuccessMessage.js';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { isIE } from 'react-device-detect';
import { textStyle } from "../../v2/theme";
import { View, Image, Text, ScrollView, TouchableOpacity, Linking } from 'react-native';
var TwoFactorAuthentication = /** @class */function (_super) {
  __extends(TwoFactorAuthentication, _super);
  function TwoFactorAuthentication(props) {
    var _this = _super.call(this, props) || this;
    _this.checked = function (value) {
      return _this.state.verificationPreference == value;
    };
    _this.getQrCode = function () {
      var layout = _this.props.layout;
      fetch("".concat(layout.pennyHomeUrl, "api/account/get_qr_code"), {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        }
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        _this.setState({
          qr: "data:image/png;base64,".concat(data.imageAsBase64String),
          secret: data.encodedSecret,
          qrUrl: data.qrUrl
        });
      });
    };
    _this.update_two_factor = function () {
      var layout = _this.props.layout;
      _this.state.loanId = layout.selectedLoanNumber;
      fetch("".concat(layout.pennyHomeUrl, "api/account/update_two_factor"), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(layout.token)
        },
        body: JSON.stringify(_this.state)
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        if (data) {
          _this.setState({
            confirmFinal: true,
            loading: false
          }, function () {
            return _this.props.get_user_profile();
          });
        } else {
          _this.setState({
            confirmFinal: false,
            loading: false
          });
        }
      });
    };
    _this.state = {
      verificationPreference: _this.props.layout.userProfile.selected_tfa_type,
      qr: null,
      secret: "",
      confirmFinal: false,
      loading: false,
      confirmAuthenticatorCode: "",
      notchagned: true,
      loanId: _this.props.layout.selectedLoanNumber
    };
    return _this;
  }
  TwoFactorAuthentication.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations;
    var _b = this.state,
      confirmAuthenticatorCode = _b.confirmAuthenticatorCode,
      confirmFinal = _b.confirmFinal,
      notchagned = _b.notchagned,
      qr = _b.qr,
      qrUrl = _b.qrUrl;
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      var _a, _b, _c, _d;
      return /*#__PURE__*/React.createElement(View, {
        style: {
          width: "100%",
          paddingBottom: 100
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "Two Factor Authentication"
      }), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%"
        }
      }, confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false
          });
        },
        message: translations.TwoFactorSuccessMessage
      }) : null, /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderContainerStyles: styles.accountSettings.titleContainer,
        item: translations.twoFactor
      }), /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          backgroundColor: "gry",
          padding: 25,
          marginBottom: 20,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          borderColor: "#efefef",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          elevation: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: __assign({
          marginBottom: 25
        }, textStyle.defaultTextDescription)
      }, translations.SecondaryVerification), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 10,
          marginRight: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbEmailMessage',
        value: "email",
        status: _this.checked("email") ? "checked" : "unchecked",
        onPress: function () {
          _this.setState({
            verificationPreference: "email",
            notchagned: false
          });
        }
      }), /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'txtEmailMessage',
        style: textStyle.defaultTextDescription
      }, translations.EmailMessage, " ", translations.SendVerificationCodesEmail, ".")), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          textDecoration: ((_b = (_a = layout === null || layout === void 0 ? void 0 : layout.userProfile) === null || _a === void 0 ? void 0 : _a.verified_phone_number) === null || _b === void 0 ? void 0 : _b.length) > 0 ? "unset" : "line-through",
          marginBottom: 10,
          marginRight: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbTextSMSMessage',
        value: "text",
        disabled: !(((_d = (_c = layout === null || layout === void 0 ? void 0 : layout.userProfile) === null || _c === void 0 ? void 0 : _c.verified_phone_number) === null || _d === void 0 ? void 0 : _d.length) > 0),
        status: _this.checked("sms") ? "checked" : "unchecked",
        onPress: function () {
          _this.setState({
            verificationPreference: "sms",
            notchagned: false
          });
        }
      }), /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'txtTextSMSMessage',
        style: textStyle.defaultTextDescription
      }, translations.TextSMSMessage, " ", translations.SendVerificationCodesTextMessage)), /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 10,
          marginRight: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbGoogleAuth',
        value: "google",
        status: _this.checked("ga") ? "checked" : "unchecked",
        onPress: function () {
          _this.setState({
            verificationPreference: "ga",
            authenticator: "",
            notchagned: false
          }, _this.getQrCode());
        }
      }), /*#__PURE__*/React.createElement(PnmacText, {
        idTag1: 'txtGoogleAuth',
        style: textStyle.defaultTextDescription
      }, translations.GoogleAuthenticator, "\u2122 ", translations.VerificationCodesMobileDevice)), _this.checked("ga") ? /*#__PURE__*/React.createElement(View, {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingLeft: 37,
          paddingRight: 37,
          height: isIE ? "100%" : "auto"
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: __assign({
          cursor: "pointer"
        }, textStyle.defaultTextDescription),
        onClick: function () {
          return _this.getQrCode();
        }
      }, "Need a new code?"), /*#__PURE__*/React.createElement(View, {
        style: {
          width: "30%",
          height: "100%"
        }
      }, layout.mobile ? /*#__PURE__*/React.createElement(Image, {
        width: "100%",
        source: {
          uri: qr
        }
      }) : /*#__PURE__*/React.createElement("img", {
        width: "100%",
        src: qr
      })), /*#__PURE__*/React.createElement(PnmacText, {
        style: __assign({
          marginBottom: 7
        }, textStyle.defaultTextDescription)
      }, "Can\u2019t scan the barcode?"), /*#__PURE__*/React.createElement(View, {
        style: {
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(PnmacPaper, null, /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextDescription
      }, "Enter your secret key:"), /*#__PURE__*/React.createElement(PnmacText, {
        style: textStyle.defaultTextTitle
      }, _this.state.secret))), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: {
          width: "100%"
        }
      }, "Need to install Google Authenticator? Go to", /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          Linking.openURL("https://support.google.com/accounts/answer/1066447?hl=en");
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: {
          textDecoration: "none"
        },
        target: "_blank"
      }, "Google\u2019s instruction page.")), /*#__PURE__*/React.createElement(Text, null, "Windows Phone users can use "), /*#__PURE__*/React.createElement(TouchableOpacity, {
        onPress: function () {
          Linking.openURL("http://www.windowsphone.com/en-us/store/app/authenticator/e7994dbc-2336-4950-91ba-ca22d653759b");
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: {
          textDecoration: "none"
        },
        target: "_blank"
      }, "Microsoft Authenticator ")), /*#__PURE__*/React.createElement(Text, null, "instead.")), /*#__PURE__*/React.createElement(View, null), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: __assign({
          alignSelf: "flex-start"
        }, textStyle.defaultTextDescription)
      }, "Please enter the Authenticator code displayed on your device to confirm it is working."), /*#__PURE__*/React.createElement(View, {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        accessibilityLabel: "Confirm Auth Code",
        idTag1: 'txtConfirmAuthCode',
        style: {
          marginTop: 10,
          width: "100%"
        },
        value: confirmAuthenticatorCode,
        mode: "outlined",
        label: 'Authenticator Verification Code (Required)',
        onChangeText: function (confirmAuthenticatorCode) {
          return _this.setState({
            confirmAuthenticatorCode: confirmAuthenticatorCode,
            notchagned: false
          });
        }
      }))) : null), /*#__PURE__*/React.createElement(View, {
        style: styles.accountSettings.buttonContainer
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnTwoFactorAuthChange',
        loading: _this.state.loading,
        style: [styles.accountSettings.button, {
          marginHorizontal: 20
        }],
        disabled: notchagned,
        onPress: function () {
          _this.setState({
            loading: true
          }, function () {
            _this.update_two_factor();
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "TwoFactor Authentication Change Button Clicked", 0);
          });
        }
      }, translations.Change)))));
    });
  };
  return TwoFactorAuthentication;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorAuthentication);